import appConfigCoverGoUat from "./appConfigCoverGoUat"
import { COVERGO_SAAS_DEV } from "../consts.js"

export const liberty = {
	"liberty-uat-studio.quote.hk": {
		appConfig: appConfigCoverGoUat,
		envConfig: COVERGO_SAAS_DEV
	}
}
